import { useEffect, useState, useRef } from "react";
import { FaWordpress, FaTimes, FaTimesCircle, FaFileInvoiceDollar, FaPhoneAlt, FaMoneyBillWave, FaUser, FaRegCalendarAlt, FaBoxOpen, FaSearch, FaQuestionCircle, FaMicrophone, FaStop, FaPlay, FaPause, FaTrash, FaPen, FaUpload, FaFileAudio } from "react-icons/fa";
import SearchIcon from '@mui/icons-material/Search';
import { BACKEND } from "../config/configEnvs";
import axios from "axios";
import LoadingScreen from "../components/ui/temp-screens/LoadingScreen";
import NoDataScreen from "../components/ui/temp-screens/NoDataScreen";
import PaginationItem from "../components/ui/components/Pagination";
import Button from '@mui/material/Button';
import DetailsButton from "../components/ui/components/DetailsButton";
import { toast } from "react-toastify";
import DrawerCotizacionCalendarioPagosDetails from "../components/calendarioPagos/DrawerCotizacionCalendarioPagosDetails";
import { useSelector } from "react-redux";
// Material-UI imports no longer needed for this component
import { formatDate } from "../utils/rawData/dateValues";
import Selector from "../components/ui/components/Selector";
import { months, years } from "../utils/rawData/dateValues";
import AddIcon from '@mui/icons-material/Add';
import Modal from "../components/ui/Modal";
import InputFormValue from "../components/ui/components/InputFormValue";
import { FaNoteSticky } from "react-icons/fa6";
import { FormControl, InputLabel, ListItemText,RegistroLlamadasManualesMenuItem, OutlinedInput, Select, Checkbox, CircularProgress, MenuItem } from "@mui/material";
import { Upload } from "@mui/icons-material";
import IdButton from "../components/ui/components/IdButton";
import CopyToClipBoard from "../utils/CopyToClipBoard";
import CallReasons from "../utils/plainValues/CallReasons";

const RegistroLlamadasManuales = () => {

  const user = useSelector((state) => state.auth.user);
  const isAdmin = user.area.toUpperCase() === "ADMINISTRACION"

  const [loading, setLoading] = useState(false);

  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(100);
  const [brandName, setBrandName] = useState("");

  const [month, setMonth] = useState(new Date().getMonth() + 1);
  const [year, setYear] = useState(new Date().getFullYear());

  const [workers, setWorkers] = useState([]);
  const [selectedWorker, setSelectedWorker] = useState(null);

  const [services, setServices] = useState([]);
  const [searchResults, setSearchResults] = useState([]);
  const [searchingClients, setSearchingClients] = useState(false);

  const [clientName, setClientName] = useState("");
  const [selectedClient, setSelectedClient] = useState(null);
  const [isClientSelected, setIsClientSelected] = useState(false);
  const [selectClientModal, setSelectClientModal] = useState(false);

  const [uploadingStatus, setUploadingStatus] = useState(false);

  // Estados para la grabación de audio
  const [isRecording, setIsRecording] = useState(false);
  const [mediaRecorder, setMediaRecorder] = useState(null);
  const [audioBlob, setAudioBlob] = useState(null);
  const [audioUrl, setAudioUrl] = useState(null);
  const [recordingTime, setRecordingTime] = useState(0);
  const [isPlaying, setIsPlaying] = useState(false);
  const [audioPlayer, setAudioPlayer] = useState(null);
  
  // Estados para archivos de audio subidos
  const [uploadedAudioFile, setUploadedAudioFile] = useState(null);
  const [uploadedAudioUrl, setUploadedAudioUrl] = useState(null);
  const fileInputRef = useRef(null);

  const [newRegisterModal, setNewRegisterModal] = useState(false);
  const [newRegisterForm, setNewRegisterForm] = useState({
    worker: user.id,
    category: "Operativa",
    month: new Date().getMonth() + 1,
    year: new Date().getFullYear(),
    client: "",
    audio: "",
    numberCalled: "",
    servicesOfInterest: "", // String con servicios separados por comas
    notes: "",
    quotes: [],
    quotesInput: "", // Campo separado para el input
    reason: ""
  });

  // Estado separado para los motivos seleccionados
  const [selectedReasons, setSelectedReasons] = useState([]);

  // Función para calcular la categoría automáticamente basada en el trabajador
  const calculateCategory = (workerId) => {
    if (!workerId) return "Operativa"; // Categoría por defecto
    
    const selectedWorker = workers.find(worker => worker.id === workerId);
    if (!selectedWorker || !selectedWorker.area) return "Operativa";
    
    const area = selectedWorker.area.toUpperCase();
    
    switch (area) {
      case "ADMINISTRACION":
        return "Administración";
      case "COMERCIAL": 
        return "Comercial";
      default:
        return "Operativa"; // Categoría por defecto
    }
  };

  // Calcular categoría automáticamente cuando cambie el trabajador
  const callCategory = calculateCategory(newRegisterForm.worker);

  // useEffect para actualizar automáticamente la categoría cuando cambie el trabajador
  useEffect(() => {
    const calculatedCategory = calculateCategory(newRegisterForm.worker);
    setNewRegisterForm(prev => ({
      ...prev,
      category: calculatedCategory
    }));
  }, [newRegisterForm.worker, workers]);

  useEffect(() => {
    const calculatedCategory = calculateCategory(newRegisterForm.worker);
    setNewRegisterForm(prev => ({
      ...prev,
      category: calculatedCategory
    }));
  }, []);

  const [record, setRecord] = useState([]);
  const [totalDocs, setTotalDocs] = useState(0);
  const [totalPages, setTotalPages] = useState(0);

  // Estado separado para los IDs de servicios seleccionados
  const [selectedServiceIds, setSelectedServiceIds] = useState([]);

  // Funciones para manejar servicios con IDs
  const handleServicesChange = (event) => {
    const selectedIds = event.target.value;
    
    // Actualizar el estado de IDs seleccionados
    setSelectedServiceIds(selectedIds);
    
    // Obtener los nombres de servicios que coinciden con los IDs seleccionados
    const selectedServiceNames = services
      .filter(service => selectedIds.includes(service.id))
      .map(service => service.name);
    
    // Actualizar el formulario con los nombres de servicios
    const servicesString = selectedServiceNames.join(', ');
    
    setNewRegisterForm(prev => ({ ...prev, servicesOfInterest: servicesString }));
  };

  // Función para verificar si un servicio está seleccionado
  const isServiceSelected = (serviceId) => {
    return selectedServiceIds.includes(serviceId);
  };

  // Funciones para manejar motivos de llamada
  const handleReasonsChange = (event) => {
    const selectedValues = event.target.value;
    
    // Actualizar el estado de motivos seleccionados
    setSelectedReasons(selectedValues);
    
    // Actualizar el formulario con los motivos como string separado por comas
    const reasonsString = selectedValues.join(', ');
    
    setNewRegisterForm(prev => ({ ...prev, reason: reasonsString }));
  };

  // Función para verificar si un motivo está seleccionado
  const isReasonSelected = (reasonValue) => {
    return selectedReasons.includes(reasonValue);
  };

  const getRecord = async () => {
    try {
      setLoading(true)

      // let url = `${BACKEND}/api/registroLlamadasManuales?page=${page}&limit=${limit}`
      let url = ""

      if (isAdmin) {
        url = `${BACKEND}/api/registroLlamadasManuales?page=${page}&limit=${limit}`

        if (brandName) {
          url += `&where[client.nombreComercial][contains]=${brandName}`
        }
        if (month) {
          url += `&where[month][equals]=${month}`
        }
        if (year) {
          url += `&where[year][equals]=${year}`
        }

      } else {
        url = `${BACKEND}/api/registroLlamadasManuales?page=${page}&limit=${limit}&where[worker][equals]=${user.id}&where[category][not_equals]=Administración`
      }

      const response = await axios.get(url)

      setRecord(response.data.docs)
      setTotalDocs(response.data.totalDocs)
      setTotalPages(response.data.totalPages)

    } catch (error) {
      return null
    } finally {
      setLoading(false)
    }
  }

  const searchClients = async () => {
    if (!clientName.trim()) {
      setSearchResults([]);
      return;
    }

    try {
      setSearchingClients(true);
      const response = await axios.get(`${BACKEND}/api/clientesuser?limit=10&where[nombreComercial][like]=${encodeURIComponent(clientName)}`);
      setSearchResults(response.data.docs || []);
    } catch (error) {
      console.error('Error searching clients:', error);
      toast.error('Error al buscar clientes');
      setSearchResults([]);
    } finally {
      setSearchingClients(false);
    }
  };

  const selectClient = (client) => {
    setSelectedClient(client);
    setNewRegisterForm(prev => ({ ...prev, client: client.id }));
    setClientName(client.nombreComercial);
    setSearchResults([]);
    setIsClientSelected(true);
    if (client.telefono || client.telefonoGerente) {
      setNewRegisterForm(prev => ({ ...prev, numberCalled: client.telefono || client.telefonoGerente }));
    }
  };

  const clearClientSelection = () => {
    setSelectedClient(null);
    setNewRegisterForm(prev => ({ ...prev, client: "", numberCalled: "" }));
    setClientName("");
    setSearchResults([]);
    setIsClientSelected(false);
  };

  const processQuotesInput = (inputValue) => {
    // Procesar el input y extraer IDs válidos
    const quotesArray = inputValue
      .split(',')
      .map(id => id.trim())
      .filter(id => {
        // Filtrar solo IDs válidos: exactamente 24 caracteres hexadecimales
        return id.length === 24 && /^[a-fA-F0-9]{24}$/.test(id);
      });
    
    // Actualizar el array de quotes válidos
    setNewRegisterForm(prev => ({ ...prev, quotes: quotesArray }));
  };

  const resetForm = () => {
    setNewRegisterForm({
      worker: user.id,
      category: calculateCategory(newRegisterForm.worker),
      month: new Date().getMonth() + 1,
      year: new Date().getFullYear(),
      client: "",
      audio: "",
      numberCalled: "",
      servicesOfInterest: "", // String vacía para servicios
      notes: "",
      quotes: [],
      quotesInput: "",
      reason: ""
    });
    // Limpiar el estado de servicios seleccionados
    setSelectedServiceIds([]);
    // Limpiar el estado de motivos seleccionados
    setSelectedReasons([]);
    clearClientSelection();
    // Limpiar audio
    clearAudio();
  };

  // Funciones para grabación de audio
  const startRecording = async () => {
    // Verificar si ya hay un archivo subido
    if (uploadedAudioFile) {
      toast.error('Ya tienes un archivo de audio subido. Elimínalo primero para poder grabar.');
      return;
    }

    // Verificar si ya hay un audio grabado
    if (audioBlob) {
      toast.error('Ya tienes un audio grabado. Elimínalo primero para poder grabar uno nuevo.');
      return;
    }

    try {
      const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
      const recorder = new MediaRecorder(stream);
      const audioChunks = []; // Array local para esta sesión

      recorder.ondataavailable = (event) => {
        if (event.data.size > 0) {
          audioChunks.push(event.data);
        }
      };

      recorder.onstop = () => {
        const blob = new Blob(audioChunks, { type: 'audio/wav' });
        const audioFile = new File([blob], "audio.wav", { type: 'audio/wav' });
        const url = URL.createObjectURL(blob);
        setAudioBlob(audioFile);
        setAudioUrl(url);
        setNewRegisterForm(prev => ({ ...prev, audio: audioFile }));
        
        // Detener el stream para liberar el micrófono
        stream.getTracks().forEach(track => track.stop());
      };

      setMediaRecorder(recorder);
      recorder.start();
      setIsRecording(true);
      setRecordingTime(0);

      // Timer para mostrar el tiempo de grabación
      const timer = setInterval(() => {
        setRecordingTime(prev => prev + 1);
      }, 1000);

      recorder.addEventListener('stop', () => {
        clearInterval(timer);
      });

    } catch (error) {
      console.error('Error accessing microphone:', error);
      toast.error('Error al acceder al micrófono');
    }
  };

  const stopRecording = () => {
    if (mediaRecorder && isRecording) {
      mediaRecorder.stop();
      setIsRecording(false);
    }
  };

  const playAudio = () => {
    const audioUrlToPlay = audioUrl || uploadedAudioUrl;
    if (audioUrlToPlay) {
      const audio = new Audio(audioUrlToPlay);
      audio.play();
      setIsPlaying(true);
      setAudioPlayer(audio);

      audio.onended = () => {
        setIsPlaying(false);
        setAudioPlayer(null);
      };
    }
  };

  const pauseAudio = () => {
    if (audioPlayer) {
      audioPlayer.pause();
      setIsPlaying(false);
      setAudioPlayer(null);
    }
  };

  const clearAudio = () => {
    // Detener grabación si está activa
    if (mediaRecorder && isRecording) {
      mediaRecorder.stop();
    }
    
    // Detener reproducción si está activa
    if (audioPlayer) {
      audioPlayer.pause();
    }
    
    // Limpiar URL del audio grabado
    if (audioUrl) {
      URL.revokeObjectURL(audioUrl);
    }
    
    // Limpiar URL del archivo subido
    if (uploadedAudioUrl) {
      URL.revokeObjectURL(uploadedAudioUrl);
    }
    
    // Resetear todos los estados de audio
    setAudioBlob(null);
    setAudioUrl(null);
    setUploadedAudioFile(null);
    setUploadedAudioUrl(null);
    setIsPlaying(false);
    setAudioPlayer(null);
    setRecordingTime(0);
    setIsRecording(false);
    setMediaRecorder(null);
    setNewRegisterForm(prev => ({ ...prev, audio: "" }));
    
    // Limpiar el input de archivo
    if (fileInputRef.current) {
      fileInputRef.current.value = '';
    }
  };

  // Función para manejar la subida de archivos de audio
  const handleFileUpload = (event) => {
    const file = event.target.files[0];
    if (!file) return;

    // Verificar si se está grabando
    if (isRecording) {
      toast.error('No puedes subir un archivo mientras estás grabando. Detén la grabación primero.');
      return;
    }

    // Validar que sea un archivo de audio
    if (!file.type.startsWith('audio/')) {
      toast.error('Por favor selecciona un archivo de audio válido');
      return;
    }

    // Validar tamaño del archivo (máximo 50MB)
    const maxSize = 50 * 1024 * 1024; // 50MB
    if (file.size > maxSize) {
      toast.error('El archivo es demasiado grande. Máximo 50MB');
      return;
    }

    // Limpiar audio grabado si existe
    if (audioBlob) {
      clearAudio();
    }

    // Crear URL para previsualización
    const url = URL.createObjectURL(file);
    setUploadedAudioFile(file);
    setUploadedAudioUrl(url);
    setNewRegisterForm(prev => ({ ...prev, audio: file }));
  };

  // Función para limpiar solo el archivo subido
  const clearUploadedFile = () => {
    if (uploadedAudioUrl) {
      URL.revokeObjectURL(uploadedAudioUrl);
    }
    setUploadedAudioFile(null);
    setUploadedAudioUrl(null);
    setNewRegisterForm(prev => ({ ...prev, audio: "" }));
    
    if (fileInputRef.current) {
      fileInputRef.current.value = '';
    }
  };

  // Función para verificar si hay algún audio (grabado o subido)
  const hasAnyAudio = () => {
    return audioBlob || uploadedAudioFile;
  };

  // Función para formatear el tamaño del archivo
  const formatFileSize = (bytes) => {
    if (bytes === 0) return '0 Bytes';
    const k = 1024;
    const sizes = ['Bytes', 'KB', 'MB', 'GB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(1)) + ' ' + sizes[i];
  };

  const formatTime = (seconds) => {
    const mins = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${mins}:${secs.toString().padStart(2, '0')}`;
  };

  const uploadAudio = async () => {
    // Verificar si hay algún audio (grabado o subido)
    const audioToUpload = audioBlob || uploadedAudioFile;
    if (!audioToUpload) return null;

    try {
      const formData = new FormData();
      const file = audioToUpload instanceof File 
        ? audioToUpload 
        : new File([audioToUpload], 'audio.wav', { type: 'audio/wav' });
      formData.append("file", file);

      // Subir el audio
      const response = await axios.post(`${BACKEND}/api/audiosLlamadasManuales`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      });

      console.log("RPTA")
      console.log(response)

      // Retornar el ID del audio subido
      return (response?.data?.doc?.id) || (response?.data?.id);
    } catch (error) {
      console.log(error);
      toast.error('Error al subir el audio');
      return null;
    }
  };

  const handleSubmit = async () => {
    try {
      // Validaciones
      if (!newRegisterForm.client) {
        toast.error('Debes seleccionar un cliente');
        return;
      }

      if (!newRegisterForm.numberCalled) {
        toast.error('Debes ingresar el número de llamada');
        return;
      }

      if (!newRegisterForm.reason) {
        toast.error('Debes seleccionar el motivo de la llamada');
        return;
      }

      setUploadingStatus(true)

      // Si hay audio (grabado o subido), subirlo primero
      let audioId = null;
      if (hasAnyAudio()) {
        audioId = await uploadAudio();
        if (!audioId) {
          console.log("No hay audio xde")
          toast.error('Error al subir el audio');
          return;
        }
      }

      // Preparar datos del formulario
      const formData = {
        ...newRegisterForm,
        audio: audioId // Reemplazar el blob con el ID del audio
      };

      // Enviar el formulario
      await axios.post(`${BACKEND}/api/registroLlamadasManuales`, formData);

      toast.success('Registro guardado exitosamente');
      setNewRegisterModal(false);
      resetForm();
      clearAudio(); // Asegurar que el audio se limpie completamente
      getRecord(); // Actualizar la lista

    } catch (error) {
      console.error('Error submitting form:', error);
      toast.error('Error al guardar el registro');
    } finally {
      setUploadingStatus(false)
    }
  };

  const getWorkers = async () => {
    try {
      const response = await axios.get(`${BACKEND}/api/trabajadores?limit=0`)
      // const sellers = response.data.docs.filter((v) => v.area.toUpperCase() === "COMERCIAL" || v.area.toUpperCase() === "ADMINISTRACION")
      // setWorkers(sellers)
      setWorkers(response.data.docs)
    } catch (error) {
      return null
    }
  }

  const getServices = async () => {
    try {
      const response = await axios.get(`${BACKEND}/api/servicios?limit=0`)
      setServices(response.data.docs)
    } catch (error) {
      return null
    }
  }

  const handleSearchClients = () => { // Buscamos clientes y colocamos página 1
    setPage(1)
    getRecord()
  }

  const handleResetSearch = () => { // Resetea la búsqueda
    setBrandName(""); // Cambiar el estado
  };

  useEffect(() => {
    getRecord()
  }, [page, limit])

  useEffect(() => {
    getRecord()
    getWorkers()
    getServices()
  }, [])

  useEffect(() => { 
    if (brandName === "") {
      getRecord(); 
      setPage(1); 
    }
  }, [brandName]);

  // Limpiar audio cuando se abre el modal
  useEffect(() => {
    if (newRegisterModal) {
      clearAudio();
    }
  }, [newRegisterModal]);

  const [noteSelected, setNoteSelected] = useState("");
  const [noteSelectedModal, setNoteSelectedModal] = useState(false);

  return (
    <div className="flex flex-col h-screen w-full">

      {/* Modal de notas de la llamada */}
      <Modal
        activeModal={noteSelectedModal}
        onClose={() => setNoteSelectedModal(false)}
        title="Notas de la llamada"
        centered
        className="max-w-3xl"
      >
        <div className="flex flex-col gap-4">
          <div className="flex flex-row items-center gap-2">
            <span className="text-xs font-bold">Notas de la llamada</span>
            <FaPen className="text-blue-500 text-xs"/>
          </div>
          <div className="border border-gray-300 rounded-lg p-4">
            <span className="text-xs">{noteSelected}</span>
          </div>
        </div>
      </Modal>

      {/* Modal de registro de llamada */}
      <Modal
        activeModal={newRegisterModal}
        onClose={() => {
          setNewRegisterModal(false);
          resetForm();
        }}
        title="Nuevo registro de llamada"
        centered
        className="max-w-3xl"
      >
        <div className="gap-4 h-[75vh] overflow-y-auto">
          <div className="flex flex-col gap-4">
            {/* Contenido del formulario */}

            <InputFormValue
              title="Trabajador"
              info="Trabajador que realizó la llamada."
              value={user.name}
              // setValue={(value) => setNewRegisterForm(prev => ({ ...prev, worker: value }))}
              icon={<FaUser />}
              placeholder="Trabajador"
              disabled
              type="text"
              // options={[
              //   { value: user.id, label: user.name },
              //   ...workers.map((w) => ({ value: w.id, label: w.name })),
              // ]}
            />

            {/* Búsqueda de clientes */}
            <div className="relative">
              <label className="flex flex-row items-center text-xs block text-gray-700 mb-1">
                Cliente
                {isClientSelected && (
                  <button 
                    onClick={clearClientSelection}
                    className="ml-2 text-red-500 hover:text-red-700 text-xs"
                  >
                    <FaTimes />
                  </button>
                )}
              </label>
              <div className="flex">
                <span className="text-xs inline-flex items-center px-3 text-gray-900 bg-gray-200 border rounded-e-0 border-gray-300 border-e-0 rounded-s-md">
                  <FaUser />
                </span>
                <div className="flex flex-1">
                  <input
                    type="text"
                    placeholder={isClientSelected ? selectedClient?.nombreComercial : "Buscar cliente por nombre comercial..."}
                    value={clientName}
                    onChange={(e) => {
                      setClientName(e.target.value);
                      if (!e.target.value.trim()) {
                        setSearchResults([]);
                      }
                    }}
                    disabled={isClientSelected}
                    className={`text-xs bg-gray-50 border text-gray-900 focus:ring-blue-500 focus:border-blue-500 block flex-1 min-w-0 w-full text-sm border-gray-300 p-2.5 ${
                      isClientSelected ? 'bg-gray-100 cursor-not-allowed' : 'rounded-none'
                    }`}
                  />
                  <button
                    onClick={searchClients}
                    disabled={!clientName.trim() || isClientSelected || searchingClients}
                    className="px-3 py-2 bg-blue-500 text-white text-xs rounded-r-lg hover:bg-blue-600 disabled:bg-gray-300 disabled:cursor-not-allowed flex items-center justify-center"
                  >
                    {searchingClients ? (
                      <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white"></div>
                    ) : (
                      <FaSearch />
                    )}
                  </button>
                </div>
              </div>
              
              {/* Lista de resultados */}
              {searchResults.length > 0 && !isClientSelected && (
                <div className="absolute z-50 w-full mt-1 bg-white border border-gray-300 rounded-lg shadow-lg max-h-60 overflow-y-auto">
                  {searchResults.map((client) => (
                    <div
                      key={client.id}
                      onClick={() => selectClient(client)}
                      className="p-3 hover:bg-gray-50 cursor-pointer border-b border-gray-100 last:border-b-0"
                    >
                      <div className="font-medium text-sm text-gray-900">{client.nombreComercial}</div>
                      <div className="text-xs text-gray-500">{client.razonSocial}</div>
                      <div className="text-xs text-gray-400">{client.email}</div>
                    </div>
                  ))}
                </div>
              )}
              
              {/* Cliente seleccionado */}
              {isClientSelected && selectedClient && (
                <div className="mt-2 p-3 bg-green-50 border border-green-200 rounded-lg">
                  <div className="flex items-center justify-between">
                    <div>
                      <div className="font-medium text-sm text-green-800">{selectedClient.nombreComercial}</div>
                      <div className="text-xs text-green-600">{selectedClient.razonSocial}</div>
                      <div className="text-xs text-green-500">{selectedClient.email}</div>
                    </div>
                    <div className="text-green-500">
                      <FaUser />
                    </div>
                  </div>
                </div>
              )}
            </div>

            {/* Número de llamada */}
            <InputFormValue
              title="Número de llamada"
              info="Número de llamada que se registró."
              value={newRegisterForm.numberCalled}
              setValue={(value) => setNewRegisterForm(prev => ({ ...prev, numberCalled: value }))}
              icon={<FaPhoneAlt />}
              placeholder="Número de llamada"
              type="text"
            />

            {/* Motivos de la llamada */}
            <div>
              <label className="flex flex-row items-center text-xs block text-gray-700 mb-1">
                Motivos de la llamada
              </label>
              <div className="flex">
                <span className="text-xs inline-flex items-center px-3 text-gray-900 bg-gray-200 border rounded-e-0 border-gray-300 border-e-0 rounded-s-md">
                  <FaQuestionCircle />
                </span>
                <FormControl sx={{ flex: 1, minWidth: 0 }}>
                  <Select
                    multiple
                    value={selectedReasons}
                    onChange={handleReasonsChange}
                    input={
                      <OutlinedInput 
                        sx={{ 
                          fontSize: '0.875rem',
                          borderRadius: '0 0.5rem 0.5rem 0',
                          backgroundColor: '#f9fafb',
                          border: '1px solid #d1d5db',
                          color: '#111827',
                          height: '42px',
                          '& .MuiOutlinedInput-notchedOutline': {
                            border: 'none'
                          },
                          '&:hover .MuiOutlinedInput-notchedOutline': {
                            border: 'none'
                          },
                          '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                            border: '2px solid #3b82f6'
                          },
                          '& .MuiSelect-select': {
                            padding: '0.625rem',
                            fontSize: '0.875rem',
                            color: '#111827'
                          }
                        }}
                      />
                    }
                    renderValue={(selected) => {
                      if (selected.length === CallReasons.length) return "Todos los motivos";
                      if (selected.length === 0) return "Seleccionar motivos";
                      return selected.join(', ');
                    }}
                    displayEmpty
                    MenuProps={{
                      disablePortal: false,
                      PaperProps: {
                        style: {
                          maxHeight: 48 * 6.5,
                          width: 250,
                          zIndex: 99999,
                          position: 'fixed'
                        }
                      },
                      anchorOrigin: {
                        vertical: 'bottom',
                        horizontal: 'left',
                      },
                      transformOrigin: {
                        vertical: 'top',
                        horizontal: 'left',
                      },
                      style: {
                        zIndex: 99999
                      }
                    }}
                  >
                    {CallReasons.map((reason, index) => {
                      const isSelected = isReasonSelected(reason.value);
                      return (
                        <MenuItem key={index} value={reason.value} sx={{ height: "40px", fontSize: '0.875rem' }}>
                          <Checkbox 
                            checked={isSelected} 
                            sx={{ padding: '4px' }}
                          />
                          <ListItemText 
                            primary={reason.label} 
                            primaryTypographyProps={{ 
                              fontSize: '0.875rem', 
                              fontFamily: "Poppins, sans-serif",
                              color: '#111827'
                            }}
                          />
                        </MenuItem>
                      );
                     })}
                  </Select>
                </FormControl>
              </div>
            </div>

            {/* Servicios relacionados */}
            <div>
              <label className="flex flex-row items-center text-xs block text-gray-700 mb-1">
                Servicios relacionados
              </label>
              <div className="flex">
                <span className="text-xs inline-flex items-center px-3 text-gray-900 bg-gray-200 border rounded-e-0 border-gray-300 border-e-0 rounded-s-md">
                  <FaBoxOpen />
                </span>
                <FormControl sx={{ flex: 1, minWidth: 0 }}>
                  <Select
                    multiple
                    value={selectedServiceIds}
                    onChange={handleServicesChange}
                    input={
                      <OutlinedInput 
                        sx={{ 
                          fontSize: '0.875rem',
                          borderRadius: '0 0.5rem 0.5rem 0',
                          backgroundColor: '#f9fafb',
                          border: '1px solid #d1d5db',
                          color: '#111827',
                          height: '42px',
                          '& .MuiOutlinedInput-notchedOutline': {
                            border: 'none'
                          },
                          '&:hover .MuiOutlinedInput-notchedOutline': {
                            border: 'none'
                          },
                          '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                            border: '2px solid #3b82f6'
                          },
                          '& .MuiSelect-select': {
                            padding: '0.625rem',
                            fontSize: '0.875rem',
                            color: '#111827'
                          }
                        }}
                      />
                    }
                    renderValue={(selected) => {
                      if (selected.length === services.length) return "Todos los servicios";
                      if (selected.length === 0) return "Seleccionar servicios";
                      
                      // Obtener los nombres de servicios basados en los IDs seleccionados
                      const selectedServiceNames = services
                        .filter(service => selected.includes(service.id))
                        .map(service => service.name);
                      
                      return selectedServiceNames.join(', ');
                    }}
                    displayEmpty
                    MenuProps={{
                      disablePortal: false,
                      PaperProps: {
                        style: {
                          maxHeight: 48 * 6.5,
                          width: 250,
                          zIndex: 99999,
                          position: 'fixed'
                        }
                      },
                      anchorOrigin: {
                        vertical: 'bottom',
                        horizontal: 'left',
                      },
                      transformOrigin: {
                        vertical: 'top',
                        horizontal: 'left',
                      },
                      style: {
                        zIndex: 99999
                      }
                    }}
                  >
                    {services.map((service, index) => {
                      const isSelected = isServiceSelected(service.id);
                      return (
                        <MenuItem key={service.id} value={service.id} sx={{ height: "40px", fontSize: '0.875rem' }}>
                          <Checkbox 
                            checked={isSelected} 
                            sx={{ padding: '4px' }}
                          />
                          <ListItemText 
                            primary={service.name} 
                            primaryTypographyProps={{ 
                              fontSize: '0.875rem', 
                              fontFamily: "Poppins, sans-serif",
                              color: '#111827'
                            }}
                          />
                        </MenuItem>
                      );
                     })}
                  </Select>
                </FormControl>
              </div>
            </div>

            {/* Cotizaciones vinculadas */}
            <div>
              <InputFormValue
                title="Cotizaciones vinculadas"
                info="IDs de cotizaciones (ObjectId de 24 caracteres) separados por comas"
                value={newRegisterForm.quotesInput}
                setValue={(value) => {
                  // Actualizar el campo de input sin filtrar
                  setNewRegisterForm(prev => ({ ...prev, quotesInput: value }));
                  // Procesar IDs en tiempo real solo para mostrar preview
                  processQuotesInput(value);
                }}
                icon={<FaFileInvoiceDollar />}
                placeholder="689145b3eb54134dedc9814c, 689145b3eb54134dedc9814d"
                type="text"
              />
              
              {/* Mostrar preview de IDs ingresados (válidos e inválidos) */}
              {newRegisterForm.quotesInput && (
                (() => {
                  const inputValue = newRegisterForm.quotesInput;
                  if (!inputValue.trim()) return null;
                  
                  const allIds = inputValue.split(',').map(id => id.trim()).filter(id => id !== '');
                  const validIds = allIds.filter(id => id.length === 24 && /^[a-fA-F0-9]{24}$/.test(id));
                  const invalidIds = allIds.filter(id => !(id.length === 24 && /^[a-fA-F0-9]{24}$/.test(id)));
                  
                  if (allIds.length === 0) return null;
                  
                  return (
                    <div className="mt-2">
                      {invalidIds.length > 0 && (
                        <div className="mb-2">
                          <label className="text-xs text-red-600 mb-1 block">
                            IDs inválidos (deben ser 24 caracteres hexadecimales):
                          </label>
                          <div className="flex flex-wrap gap-2">
                            {invalidIds.map((invalidId, index) => (
                              <div
                                key={`invalid-${index}`}
                                className="inline-flex items-center px-2 py-1 bg-red-100 text-red-800 text-xs rounded-full border border-red-200"
                              >
                                <FaTimes className="mr-1" />
                                {invalidId.length > 20 ? `${invalidId.substring(0, 20)}...` : invalidId}
                              </div>
                            ))}
                          </div>
                        </div>
                      )}
                    </div>
                  );
                })()
              )}
               
              {/* Visualización de cotizaciones vinculadas */}
              {Array.isArray(newRegisterForm.quotes) && newRegisterForm.quotes.length > 0 && (
                <div className="mt-2">
                  <label className="text-xs text-gray-600 mb-1 block">
                    Cotizaciones identificadas ({newRegisterForm.quotes.length}):
                  </label>
                  <div className="flex flex-wrap gap-2">
                    {newRegisterForm.quotes.map((quoteId, index) => (
                      <div
                        key={index}
                        className="inline-flex items-center px-2 py-1 bg-blue-100 text-blue-800 text-xs rounded-full border border-blue-200"
                      >
                        <FaFileInvoiceDollar className="mr-1" />
                        ID: {quoteId}
                        {/* <button
                          onClick={() => {
                            const updatedQuotes = newRegisterForm.quotes.filter((_, i) => i !== index);
                            setNewRegisterForm(prev => ({ ...prev, quotes: updatedQuotes }));
                          }}
                          className="ml-2 text-blue-600 hover:text-red-600 focus:outline-none"
                        >
                          <FaTimes className="text-xs" />
                        </button> */}
                      </div>
                    ))}
                  </div>
                </div>
              )}

            </div>

            {/* Notas de la llamada */}
            <InputFormValue
              title="Notas"
              info="Notas de la llamada."
              value={newRegisterForm.notes}
              setValue={(value) => setNewRegisterForm(prev => ({ ...prev, notes: value }))}
              icon={<FaNoteSticky />}
              placeholder="Notas"
              type="textarea"
            />

            {/* Sección de audio de la llamada */}
             <div>
               <label className="flex flex-row items-center text-xs block text-gray-700 mb-1">
                 Audio de la llamada
               </label>
               
               <div className="border border-gray-300 rounded-lg p-4 bg-gray-50">
                 {!hasAnyAudio() ? (
                   // Interfaz para elegir entre grabar o subir
                   <div className="space-y-4">
                     {isRecording ? (
                       // Interfaz de grabación activa
                       <div className="flex flex-col items-center space-y-4">
                         <div className="flex items-center space-x-4">
                           <button
                             onClick={stopRecording}
                             className="flex items-center space-x-2 px-4 py-2 bg-gray-500 text-white rounded-lg hover:bg-gray-600 transition-colors"
                           >
                             <FaStop />
                             <span className="text-xs">Detener grabación</span>
                           </button>
                           <div className="flex items-center space-x-2">
                             <div className="w-3 h-3 bg-red-500 rounded-full animate-pulse"></div>
                             <span className="text-red-600 font-mono">
                               Grabando... {formatTime(recordingTime)}
                             </span>
                           </div>
                         </div>
                         
                         <p className="text-xs text-gray-500 text-center">
                           Grabando audio de la llamada...
                         </p>
                       </div>
                     ) : (
                       // Interfaz para elegir opción
                       <div>
                         <div className="text-center">
                           <p className="text-xs text-gray-600 mb-4">
                             Elige una opción para agregar audio a la llamada
                           </p>
                         </div>
                         
                         <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                           {/* Opción de grabación */}
                           <div className="border-2 border-dashed border-gray-300 rounded-lg p-4 hover:border-blue-400 transition-colors">
                             <div className="flex flex-col items-center space-y-3">
                               <div className="w-12 h-12 bg-red-100 rounded-full flex items-center justify-center">
                                 <FaMicrophone className="text-red-600 text-lg" />
                               </div>
                               <div className="text-center">
                                 <h3 className="text-sm font-medium text-gray-900">Grabar audio</h3>
                                 <p className="text-xs text-gray-500 mt-1">
                                   Graba el audio directamente desde tu micrófono
                                 </p>
                               </div>
                               <button
                                 onClick={startRecording}
                                 disabled={uploadedAudioFile}
                                 className={`flex items-center space-x-2 px-4 py-2 text-white rounded-lg transition-colors text-xs ${
                                   uploadedAudioFile 
                                     ? 'bg-gray-400 cursor-not-allowed' 
                                     : 'bg-red-500 hover:bg-red-600'
                                 }`}
                               >
                                 <FaMicrophone />
                                 <span>{uploadedAudioFile ? 'Archivo subido' : 'Iniciar grabación'}</span>
                               </button>
                             </div>
                           </div>
                           
                           {/* Opción de subir archivo */}
                           <div className="border-2 border-dashed border-gray-300 rounded-lg p-4 hover:border-blue-400 transition-colors">
                             <div className="flex flex-col items-center space-y-3">
                               <div className="w-12 h-12 bg-blue-100 rounded-full flex items-center justify-center">
                                 <FaUpload className="text-blue-600 text-lg" />
                               </div>
                               <div className="text-center">
                                 <h3 className="text-sm font-medium text-gray-900">Subir archivo</h3>
                                 <p className="text-xs text-gray-500 mt-1">
                                   Sube un archivo de audio existente
                                 </p>
                               </div>
                               <input
                                 ref={fileInputRef}
                                 type="file"
                                 accept="audio/*"
                                 onChange={handleFileUpload}
                                 className="hidden"
                               />
                               <button
                                 onClick={() => fileInputRef.current?.click()}
                                 disabled={isRecording}
                                 className={`flex items-center space-x-2 px-4 py-2 text-white rounded-lg transition-colors text-xs ${
                                   isRecording 
                                     ? 'bg-gray-400 cursor-not-allowed' 
                                     : 'bg-blue-500 hover:bg-blue-600'
                                 }`}
                               >
                                 <FaUpload />
                                 <span>{isRecording ? 'Grabando...' : 'Seleccionar archivo'}</span>
                               </button>
                             </div>
                           </div>
                         </div>
                       </div>
                     )}
                   </div>
                 ) : (
                   // Interfaz de audio (grabado o subido)
                   <div className="space-y-4">
                     {audioBlob ? (
                       // Audio grabado
                       <div>
                         <div className="flex items-center justify-between">
                           <div className="flex items-center space-x-2">
                             <FaMicrophone className="text-green-600" />
                             <span className="text-xs font-medium text-green-800">
                               Audio grabado ({formatTime(recordingTime)})
                             </span>
                           </div>
                           <div className="flex items-center space-x-2">
                             <span className="text-xs bg-green-100 text-green-800 px-2 py-1 rounded-full">
                               Listo para subir
                             </span>
                           </div>
                         </div>
                         
                         <div className="flex items-center justify-between bg-white p-3 rounded-lg border mt-3">
                           <div className="flex items-center space-x-3">
                             {!isPlaying ? (
                               <button
                                 onClick={playAudio}
                                 className="flex items-center justify-center w-10 h-10 bg-blue-500 text-white rounded-full hover:bg-blue-600 transition-colors"
                               >
                                 <FaPlay className="ml-1" />
                               </button>
                             ) : (
                               <button
                                 onClick={pauseAudio}
                                 className="flex items-center justify-center w-10 h-10 bg-blue-500 text-white rounded-full hover:bg-blue-600 transition-colors"
                               >
                                 <FaPause />
                               </button>
                             )}
                             <div className="flex-1">
                               <div className="text-xs font-medium">Grabación de llamada</div>
                               <div className="text-xs text-gray-500">
                                 {audioBlob ? formatFileSize(audioBlob.size) : ''}
                               </div>
                             </div>
                           </div>
                           
                           <button
                             onClick={clearAudio}
                             className="flex items-center space-x-1 px-3 py-2 text-red-600 hover:bg-red-50 rounded-lg transition-colors"
                           >
                             <FaTrash className="text-xs" />
                             <span className="text-xs">Eliminar</span>
                           </button>
                         </div>
                       </div>
                     ) : (
                       // Archivo subido
                       <div>
                         <div className="flex items-center justify-between">
                           <div className="flex items-center space-x-2">
                             <FaFileAudio className="text-blue-600" />
                             <span className="text-xs font-medium text-blue-800">
                               Archivo de audio subido
                             </span>
                           </div>
                           <div className="flex items-center space-x-2">
                             <span className="text-xs bg-blue-100 text-blue-800 px-2 py-1 rounded-full">
                               Listo para subir
                             </span>
                           </div>
                         </div>
                         
                         <div className="flex items-center justify-between bg-white p-3 rounded-lg border mt-3">
                           <div className="flex items-center space-x-3">
                             {!isPlaying ? (
                               <button
                                 onClick={playAudio}
                                 className="flex items-center justify-center w-10 h-10 bg-blue-500 text-white rounded-full hover:bg-blue-600 transition-colors"
                               >
                                 <FaPlay className="ml-1" />
                               </button>
                             ) : (
                               <button
                                 onClick={pauseAudio}
                                 className="flex items-center justify-center w-10 h-10 bg-blue-500 text-white rounded-full hover:bg-blue-600 transition-colors"
                               >
                                 <FaPause />
                               </button>
                             )}
                             <div className="flex-1">
                               <div className="text-xs font-medium">{uploadedAudioFile?.name || 'Archivo de audio'}</div>
                               <div className="text-xs text-gray-500">
                                 {uploadedAudioFile ? formatFileSize(uploadedAudioFile.size) : ''}
                               </div>
                             </div>
                           </div>
                           
                           <button
                             onClick={clearUploadedFile}
                             className="flex items-center space-x-1 px-3 py-2 text-red-600 hover:bg-red-50 rounded-lg transition-colors"
                           >
                             <FaTrash className="text-xs" />
                             <span className="text-xs">Eliminar</span>
                           </button>
                         </div>
                       </div>
                     )}
                     
                     <div className="text-xs text-gray-500 bg-blue-50 p-2 rounded border-l-4 border-blue-400">
                       <strong>Nota:</strong> El audio se subirá automáticamente cuando envíes el formulario.
                     </div>
                   </div>
                 )}
               </div>
             </div>

             {/* Botón de envío */}
             <div className="sticky bottom-0 bg-white border-t pt-4 mt-4">
              <div className="flex items-center w-full">
                <Button
                  variant="contained"
                  onClick={handleSubmit}
                  disabled={uploadingStatus}
                  endIcon={uploadingStatus ? <CircularProgress size={14} className="animate-spin" /> : <Upload size={14} />}
                  sx={{
                    fontSize: "12px",
                    fontWeight: "bold",
                    fontFamily: "poppins", 
                    padding: "8px 24px",
                    backgroundColor: "#2563eb",
                    textTransform: "none",
                    borderRadius: "8px",
                    width: "100%",
                    '&:hover': {
                      backgroundColor: "#1d4ed8",
                    }
                  }}
                >
                  Guardar registro de llamada
                </Button>
              </div>
               
               {/* Indicador de campos requeridos */}
               <div className="text-xs text-gray-500 text-center mt-2 mb-2">
                 * Los campos Cliente, Número de llamada y Motivo son obligatorios
               </div>
             </div>            

          </div>
        </div>
      </Modal>

      {/* NavBar */}
      <div className="flex flex-row px-4 py-2 bg-gray-100">
        <div className="flex flex-row w-full items-center gap-4 justify-between overflow-x-auto overflow-y-hidden px-4 [&::-webkit-scrollbar]:hidden [-ms-overflow-style:none] [scrollbar-width:none]">
          
          <div className="flex items-center gap-4 py-4">
            <FaPhoneAlt className="text-zinc-700 text-2xl" />
            <h2 className="text-2xl font-bold text-zinc-700">Registro de llamadas manuales</h2>
          </div>

          <div className="flex flex-row gap-4 items-center justify-center">

            <div className="flex flex-row text-xs text-gray-700 items-center justify-center gap-4">
              <span>Límite:</span>
              <select
                value={limit}
                onChange={(e) => setLimit(e.target.value)}
                className="text-gray-700 hover:cursor-pointer text-xs bg-white border border-gray-300 rounded-lg shadow focus:outline-none focus:ring-2 focus:ring-blue-600 focus:border-transparent py-[6px] pr-10"
              >
                <option value="30">30</option>
                <option value="40">40</option>
                <option value="50">50</option>
                <option value="100">100</option>
                <option value="200">200</option>
              </select>
            </div>

            <div className="relative w-full">
              <input
                type="text"
                placeholder="Buscar marca"
                className="w-[16rem] text-xs text-gray-700 bg-white border border-gray-300 rounded-lg shadow focus:outline-none focus:ring-2 focus:ring-blue-600 focus:border-transparent py-[6px] pr-10"
                value={brandName}
                onChange={(e) => setBrandName(e.target.value)}
              />
              {brandName && (
                <FaTimes
                  onClick={() => handleResetSearch()}
                  className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-500 hover:text-gray-700 cursor-pointer"
                />
              )}
            </div>

            <div>
              <Button
                variant="contained"
                endIcon={<SearchIcon />}
                sx={{
                  fontSize: "12px",
                  fontWeight: "bold",
                  fontFamily: "poppins",
                  padding: "4px 24px",
                  backgroundColor: "#ff6400",
                  transform: "all",
                  animationDuration: "1000",
                  textTransform: "none",
                  borderRadius: "8px",
                  '&:hover': {
                    backgroundColor: "#bb4a03",
                  }
                }}
                onClick={() => handleSearchClients()}
              >
                Buscar
              </Button>
            </div>

            <div>
              <Button 
                variant="contained"
                onClick={() => setNewRegisterModal(true)}
                endIcon={<AddIcon/>}
                sx={{
                  fontSize: "12px",
                  fontWeight: "bold",
                  fontFamily: "poppins",
                  whiteSpace: "nowrap",
                  padding: "4px 24px",
                  backgroundColor: "#ff6400",
                  transform: "all",
                  animationDuration: "1000",
                  textTransform: "none",
                  borderRadius: "8px",
                  '&:hover': {
                    backgroundColor: "#bb4a03",
                  }
                }}
              >
                Registrar llamada
              </Button>
            </div>

          </div>

        </div>
      </div>

      {/* Filtros */}
      {isAdmin && (
        <div className="flex flex-row items-center justify-between w-full bg-gray-100 mb-0.5 mt-0.5 px-6 gap-2">
          <div className="flex flex-row items-center justify-center w-full">
            <div className="flex flex-row gap-4 items-center justify-center">
              <Selector
                title="Trabajador" 
                setter={setSelectedWorker} 
                value={selectedWorker} 
                options={workers.map((s) => {
                  return {
                    value: s.id,
                    label: s.name
                  }
                })} 
                defaultValue="Todos" 
                defaultText="Todos" 
              />

              <Selector 
                title="Mes" 
                setter={setMonth} 
                value={month} 
                options={months}
              />

              <Selector 
                title="Año" 
                setter={setYear} 
                value={year} 
                options={years} 
              />
            </div>
          </div>
        </div>
      )}

      {/* Body */}
      <div className="flex-grow overflow-y-auto mt-0.5">
        {loading ? (
            <LoadingScreen />
          ) : (
            record.length === 0 ? (
              <NoDataScreen />
            ) : (
              <table className="w-full text-xs">
                <thead className="text-xs sticky top-0 text-gray-900 bg-gray-200 z-20">
                  <tr className="text-gray-700 text-center text-xs font-bold">
                    <td className="sticky left-0 w-[6.5rem] max-w-[6.5rem] px-2 py-3 text-center bg-[#FE6400] border-r border-r-white text-white border-red z-20">
                       Trabajador
                     </td>
                     <td className="px-2 py-3 text-center bg-[#FE6400] border-r border-r-white text-white border-red z-20">
                       Fecha
                     </td>
                     <td className="px-2 py-3 text-center bg-[#FE6400] border-r border-r-white text-white border-red z-20">
                       Cliente
                     </td>
                     <td className="px-2 py-3 text-center bg-[#FE6400] border-r border-r-white text-white border-red z-20">
                       Audio
                     </td>
                     <td className="px-2 py-3 text-center bg-[#FE6400] border-r border-r-white text-white border-red z-20">
                       Número llamado
                     </td>
                     <td className="px-2 py-3 text-center bg-[#FE6400] border-r border-r-white text-white border-red z-20">
                       Servicios de interés
                     </td>
                     <td className="px-2 py-3 text-center bg-[#FE6400] border-r border-r-white text-white border-red z-20">
                       Notas
                     </td>
                     <td className="px-2 py-3 text-center bg-[#FE6400] border-r border-r-white text-white border-red z-20">
                       Cotizaciones vinculadas
                     </td>
                  </tr>
                </thead>
                <tbody>
                  {record?.map((r, i) => {
                    return (
                      <tr key={i} className="text-xs py-2 w-full hover:bg-gray-100 transition-all duration-300 group">
                        <td scope="row" className="px-2 py-1 border border-gray-300 truncate text-center bg-white z-10 group-hover:bg-gray-100">
                          {r.worker.name}
                        </td>
                        <td scope="row" className="px-2 py-1 border border-gray-300 truncate text-center bg-white z-10 group-hover:bg-gray-100">
                          {new Date(r.createdAt).toLocaleString('es-ES', {
                            day: '2-digit',
                            month: 'long',
                            year: 'numeric',
                            hour: '2-digit',
                            minute: '2-digit',
                          })}
                        </td>
                        <td scope="row" className="px-2 py-1 border font-bold border-gray-300 truncate text-center bg-white z-10 group-hover:bg-gray-100">
                          {r.client.nombreComercial}
                        </td>
                        <td scope="row" className="px-2 py-1 border border-gray-300 w-[25rem] text-center bg-white group-hover:bg-gray-100">
                          <div className="w-full h-full">
                            {r.audio ? <audio className="w-full h-10" src={r.audio.url} controls /> : "-"}
                          </div>
                        </td>
                        <td scope="row" className="px-2 py-1 border border-gray-300 text-center bg-white z-10 group-hover:bg-gray-100">
                          {r.numberCalled}
                        </td>
                        <td scope="row" className="px-2 py-1 border border-gray-300 text-center bg-white z-10 group-hover:bg-gray-100">
                          {r.servicesOfInterest}
                        </td>
                        <td scope="row" className="px-2 py-1 border font-bold border-gray-300 text-center bg-white z-10 group-hover:bg-gray-100">
                          <div className="flex w-full items-center justify-center">
                            <DetailsButton
                              action={() => {
                                setNoteSelected(r.notes)
                                setNoteSelectedModal(true)
                              }}
                              content={"Notas de la llamada"}
                            />
                          </div>
                        </td>
                        <td scope="row" className="px-2 py-1 border border-gray-300 text-center bg-white z-10 group-hover:bg-gray-100">
                          <div className="flex w-full flex-row items-center gap-2 justify-center">
                            {r.quotes && r.quotes.length > 0 ? r.quotes.map((q) => {
                              return (
                                <IdButton
                                  id={q.id}
                                  text={q.id}
                                  action={() => CopyToClipBoard(q.id)}
                                  content={q.id}
                                />
                              )
                            }) : <span className="text-xs text-gray-500">-</span>}
                          </div>
                        </td>
                      </tr>
                    )
                  })}
                </tbody>
              </table>
            )
          )
        }
      </div>

      {/* Paginador */}
      <PaginationItem
        actualDocs={record.length}
        totalDocs={totalDocs}
        entity={"llamadas"}
        totalPages={totalPages}
        actualPage={page}
        handlePageChange={(event, value) => setPage(value)}
      />

    </div>
  )
}

export default RegistroLlamadasManuales;  